import { render } from "./ClockIcon.vue?vue&type=template&id=b67cbb3c&scoped=true"
const script = {}

import "./ClockIcon.vue?vue&type=style&index=0&id=b67cbb3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b67cbb3c"]])

export default __exports__